import createIcon from '../../createIcon';

/**
 * @component @name Construction
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuOTAzNiAxMy4xNjA3TDEzLjc4MjMgMTUuMjgyTDE5Ljc3ODUgMjEuMjc4MkwyMS44OTk4IDE5LjE1NjlMMTUuOTAzNiAxMy4xNjA3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3LjQ5OTYgMTAuMTEwMkMxOS40Mjk2IDEwLjExMDIgMjAuOTk5NiA4LjU0MDE2IDIwLjk5OTYgNi42MTAxNkMyMC45OTk2IDYuMDMwMTYgMjAuODM5NiA1LjQ5MDE2IDIwLjU4OTYgNS4wMTAxNkwxNy44ODk2IDcuNzEwMTZMMTYuMzk5NiA2LjIyMDE2TDE5LjA5OTYgMy41MjAxNkMxOC42MTk2IDMuMjcwMTYgMTguMDc5NiAzLjExMDE2IDE3LjQ5OTYgMy4xMTAxNkMxNS41Njk2IDMuMTEwMTYgMTMuOTk5NiA0LjY4MDE2IDEzLjk5OTYgNi42MTAxNkMxMy45OTk2IDcuMDIwMTYgMTQuMDc5NiA3LjQxMDE2IDE0LjIwOTYgNy43NzAxNkwxMi4zNTk2IDkuNjIwMTZMMTAuNTc5NiA3Ljg0MDE2TDExLjI4OTYgNy4xMzAxNkw5Ljg3OTYxIDUuNzIwMTZMMTEuOTk5NiAzLjYwMDE2QzEwLjgyOTYgMi40MzAxNiA4LjkyOTYxIDIuNDMwMTYgNy43NTk2MSAzLjYwMDE2TDQuMjE5NjEgNy4xNDAxNkw1LjYyOTYxIDguNTUwMTZIMi44MDk2MUwyLjA5OTYxIDkuMjYwMTZMNS42Mzk2MSAxMi44MDAyTDYuMzQ5NjEgMTIuMDkwMlY5LjI2MDE2TDcuNzU5NjEgMTAuNjcwMkw4LjQ2OTYxIDkuOTYwMTZMMTAuMjQ5NiAxMS43NDAyTDIuODM5NjEgMTkuMTUwMkw0Ljk1OTYxIDIxLjI3MDJMMTYuMzM5NiA5LjkwMDE2QzE2LjY5OTYgMTAuMDMwMiAxNy4wODk2IDEwLjExMDIgMTcuNDk5NiAxMC4xMTAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Construction = createIcon('Construction', [
  [
    'path',
    {
      d: 'M15.9036 13.1607L13.7823 15.282L19.7785 21.2782L21.8998 19.1569L15.9036 13.1607Z',
      key: '1bbh0r',
    },
  ],
  [
    'path',
    {
      d: 'M17.4996 10.1102C19.4296 10.1102 20.9996 8.54016 20.9996 6.61016C20.9996 6.03016 20.8396 5.49016 20.5896 5.01016L17.8896 7.71016L16.3996 6.22016L19.0996 3.52016C18.6196 3.27016 18.0796 3.11016 17.4996 3.11016C15.5696 3.11016 13.9996 4.68016 13.9996 6.61016C13.9996 7.02016 14.0796 7.41016 14.2096 7.77016L12.3596 9.62016L10.5796 7.84016L11.2896 7.13016L9.87961 5.72016L11.9996 3.60016C10.8296 2.43016 8.92961 2.43016 7.75961 3.60016L4.21961 7.14016L5.62961 8.55016H2.80961L2.09961 9.26016L5.63961 12.8002L6.34961 12.0902V9.26016L7.75961 10.6702L8.46961 9.96016L10.2496 11.7402L2.83961 19.1502L4.95961 21.2702L16.3396 9.90016C16.6996 10.0302 17.0896 10.1102 17.4996 10.1102Z',
      key: '18q3an',
    },
  ],
]);

export default Construction;
